import { Component, OnInit, OnChanges, SimpleChanges, Input } from '@angular/core';
import { Inject, NgModule } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
// patrones de enrutamiento interno
import { ActivatedRoute, Router } from '@angular/router';
// par ausar formularios contiene formGroup y formcontrol
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';
// Modelos
import { CanalEntrada } from '../../models/canal-entrada.model';
// Servicios
import { CanalEntradaService } from '../../services/canal-entrada.service';
import { GlobalUIUtilsService } from '../../services/global-ui-utils.service';
import { TranslateService } from '@ngx-translate/core';
import { Location } from '@angular/common';
import { ModelHelpers } from '../../models/ModelHelpers';

@Component({
  selector: 'app-canal-entrada-edit',
  templateUrl: './canal-entrada-edit.component.html',
  styleUrls: ['./canal-entrada-edit.component.scss']
})
export class CanalEntradaEditComponent implements OnInit {

  //Atributos
  public canalEntrada: CanalEntrada;
  public id: number;
  form: FormGroup;
  isNew: boolean;
  title: string;

  isButtonDeleteVisible = false;
  message = this.translate.instant('comunes.toastr_guardado');

  //Constructor
  constructor(private activatedRoute: ActivatedRoute, private oficinaFacturacionService: CanalEntradaService, 
    private router: Router, private _GlobalUIUtilsService: GlobalUIUtilsService, private translate: TranslateService,
    private _location: Location) { }

  //Cargar Página
  ngOnInit() {
    this.loadData();
    this.createForm();
  }

  createForm() {
    //Creamos el formulario
    this.form = new FormGroup({
      descripcion: new FormControl(''),
      filtroEntidad: new FormControl(''),
      activo: new FormControl(true)
    });
  }

  loadData() {
    // retrieve the ID from the 'id' parameter
    this.cargarVariablesUrl();
    if (this.id) {
      this.oficinaFacturacionService.get(this.id).subscribe(result => {
        this.canalEntrada = result;
        this.title = 'Editar';
        this.form.patchValue(this.canalEntrada);
        this.isNew = false;
        this.isButtonDeleteVisible = true;
      }, error => console.error(error));
    } else {
      this.title = 'Crear';
      this.isNew = true;
    }
  }

  //Se encarga de recoger las variables de la URL
  private cargarVariablesUrl() {
    this.id = +this.activatedRoute.snapshot.paramMap.get('id');
  }

  bindToModel() {
    ModelHelpers.copyFromForm(this.form.value, this.canalEntrada);
  }

  //Funciones
  onSubmit() {
    console.log("Submit");
    if (this.canalEntrada == null) {
      this.canalEntrada = new CanalEntrada();
    }
    
    // this.canalEntrada.descripcion = this.form.get('descripcion').value;
    // this.canalEntrada.filtroEntidad = this.form.get('filtroEntidad').value;
    // this.canalEntrada.activo = this.form.get('activo').value;
    this.bindToModel();

    if (this.isNew) {
      console.log("Crear");
      console.log(this.canalEntrada);
      this.oficinaFacturacionService.post(this.canalEntrada).subscribe(result => {
        console.log(`canalEntrada has been updated.`);
        this._location.back();
      }, error => console.log(error));
    } else {
      console.log("Guardar");
      this.oficinaFacturacionService.put(this.canalEntrada).subscribe(result => {
        console.log(`canalEntrada has been updated.`);
        this._GlobalUIUtilsService.success(this.message);
      }, error => console.log(error));
    }
    console.log("Fin Guardar");
  }

  onDelete() {
    console.log("Delete");
    this.oficinaFacturacionService.delete(this.canalEntrada.id).subscribe(result => {
      console.log(`canalEntrada has been updated.`);
      this.router.navigate(['/canalEntrada']);
    }, error => console.log(error));
  }


}
